import _ from 'lodash';
import { IDropdownOption } from 'src/constants/interfaces';
import { InvertEnum, TranslateFunc } from 'src/constants/types';

export const getViewEnum = <TEnum extends object>(enumObj: TEnum) => {
    const inverted = _.invert(enumObj);
    return _.pickBy(inverted, (value, key) => +key) as InvertEnum<TEnum>;
};

type ExcludePatternFunc = (key: number, value: string) => boolean;

export const getSelectOptionsFromViewEnum = <TViewEnum extends { [key: number]: string }>(
    enumObj: TViewEnum,
    translateFunc?: TranslateFunc,
    excludePattern?: ExcludePatternFunc
) => {
    const options: IDropdownOption<string, number>[] = [];


    for (const key in enumObj) {
        const name = enumObj[key];

        !excludePattern?.(+key, name) && options.push({
            value: +key,
            name: translateFunc?.(name) || name,
        });
    }

    return options;
}